import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Validated from 'components/util/Validated';
import AssetsDisale from 'components/assets/disable';
import * as Common from 'common/components';
import { Form } from 'common/components';

import AssetsSchemas from 'schemas/assets_schemas';
import { createRoute } from 'lib/util';

class AssetsDisableView extends PureComponent {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    catalogs: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleValueChange: PropTypes.func.isRequired,
    isSubmitted: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool,
    subcompany: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => {
    const { asset } = this.props;
    let indexInteger = '';
    if (asset.indexInteger && asset.indexInteger[0] && asset.indexInteger[0].indexString) {
      indexInteger = asset.indexInteger[0].indexString;
    }
    return (
      <Common.Wrapper fluid={true}>
        <Common.Header title={this.props.t('assets.title')} />
        <div className="col-12">
          <Common.Portlet
            title={this.props.t('assets.disable')}
            icon={'qrcode'}
            subtitle={`${asset.number} - ${asset.name} - ${indexInteger}`}
          >
            <form onSubmit={this.props.handleSubmit}>
              <div className="row" style={{ position: 'relative' }}>
                <AssetsDisale.Form
                  isLoading={this.props.isLoading}
                  isSubmitted={this.props.isSubmitted}
                  errors={this.props.errors}
                  asset={this.props.asset}
                  disableReason={this.props.catalogs.disableReason}
                  handleValueChange={this.props.handleValueChange}
                />
                <AssetsDisale.Depreciations asset={this.props.asset} />
                <div className="col-md-12 mt-3">
                  <Form.Button
                    type={'submit'}
                    text={this.props.t('actions.save')}
                    isLoading={this.props.isSaving}
                    disabled={this.props.isSaving}
                    extraClassName={'pull-right btn-xs-block'}
                  />

                  <Form.Link
                    to={createRoute(this.props.company.id, this.props.subcompany.id, 'assets')}
                    className={classnames('btn btn-secondary pull-right mr-3', {
                      disabled: this.props.isSaving,
                    })}
                  >
                    {this.props.t('actions.cancel')}
                  </Form.Link>
                  <div className="clearfix" />
                </div>
                <Common.LoaderOverlay show={this.props.isFetching} />
              </div>
            </form>
          </Common.Portlet>
        </div>
      </Common.Wrapper>
    );
  };
}

export default Validated(AssetsSchemas.disable)(translate()(AssetsDisableView));



// WEBPACK FOOTER //
// src/components/assets/AssetsDisableView.js